import React from 'react';

import { TextField } from '@mui/material';

type MarkdownEditorProps = {
  value?: string;
  title?: string;
  label?: string;
  showLabel?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  wrapperId?: string;
  placeholder?: string;
  onChange?: (markdown: string) => void;
  onBlur?: (markdown: string) => void;
};

function MarkdownEditor(props: MarkdownEditorProps) {
  const disabled = props.readonly || props.disabled;

  return (
    <div>
      <TextField
        label={props.showLabel ? props.label : props.title}
        value={props.value ?? ''}
        onChange={(e) => props.onChange?.(e.target.value)}
        onBlur={(e) => props.onBlur?.(e.target.value)}
        disabled={disabled}
        placeholder={props.placeholder}
        multiline
        minRows={6}
        fullWidth
      />
    </div>
  );
}

export default MarkdownEditor;
